exports.request = function(type, url, data) {
  data = data || []
  if (type === 'post') {
    data['data[token]'] = App.me.token
  }
  var dfd = new $.Deferred()
  $.ajax({
    type: type,
    url: url,
    headers: {'X-MAMARIQ-UUID': App.me.User.uuid},
    data: data
  }).done(function(data) {
    dfd.resolve(data.response)
  }).fail(function(jqXHR) {
    dfd.reject(App.parseError(jqXHR).error || [])
  })
  return dfd
}



// WEBPACK FOOTER //
// ./webroot/js/api/api-util.js